import {
  ADD_USER,
  GET_USERS,
  USERS_LOADED_FAIL,
  USERS_LOADED_SUCCESS,
  GET_USER,
  USER_LOADED_FAIL,
  USER_LOADED_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER,
  UPDATE_USER_FAIL,
  DELETE_USER
} from '../constants/constants'

export const UserReducer = (state, action) => {
  const { type, payload } = action
  switch (type) {
    case ADD_USER:
      return {
        ...state,
        addUserStatus: true
      }
    case ADD_USER_FAIL:
      return {
        ...state,
        addUserStatus: false
      }
    case DELETE_USER:
      return {
        ...state,
        users: state.users.filter((user) => user._id !== payload)
      }
    case UPDATE_USER:
      return {
        ...state,
        updateUserStatus: true
      }
    case UPDATE_USER_FAIL:
      return {
        ...state,
        updateUserStatus: false
      }
    case USERS_LOADED_SUCCESS:
      return {
        ...state,
        users: payload,
        usersLoading: false
      }
    case USERS_LOADED_FAIL:
      return {
        ...state,
        posts: [],
        usersLoading: false
      }

    case GET_USERS:
      return [...state, payload.users]

    case USER_LOADED_SUCCESS:
      return {
        ...state,
        user: payload,
        userLoading: false
      }
    case USER_LOADED_FAIL:
      return {
        ...state,
        user: [],
        userLoading: false
      }

    case GET_USER:
      return [...state, payload.user]

    default:
      return state
  }
}
